<template>
  <b-modal
    id="saldo-al-mes-siguiente"
    size="xl"
    @shown="onShown"
    centered
    hide-footer
    lazy
    scrollable
  >
    <div class="card">
      <form
        @submit.prevent="submit"
        ref="form"
        v-promise-btn="{ action: 'submit' }"
      >
        <div class="container">
          <div class="row">
            <div class="col-12 text-center form-group form-group-sm">
              <h4 class="card-title">Pasar saldo para próximo período</h4>
            </div>

            <div class="col-12 form-group form-group-sm">
              <label for="cliente" class="label">Cliente </label>
              <input
                disabled
                type="text"
                class="form-control form-control-sm text-center bg-white"
                style="cursor: text"
                v-model="nombreCliente"
                id="cliente"
              />
            </div>
            <template v-if="montoProximoPeriodo || deudaUltimaFactura">
              <div class="col-12 col-md-6 form-group form-group-sm">
                <label for="deudaActual" class="label"
                  >Monto ultima factura
                </label>
                <vue-numeric
                  id="deudaActual"
                  v-select-on-focus
                  currency="$"
                  thousand-separator="."
                  decimal-separator=","
                  :precision="2"
                  v-model="deudaUltimaFactura"
                  :minus="true"
                  disabled
                  class="form-control form-control-sm text-center bg-white"
                ></vue-numeric>
              </div>
              <div class="col-12 col-md-6 form-group form-group-sm">
                <label for="montoProximoPeriodo" class="label"
                  >Monto para siguiente mes</label
                >
                <vue-numeric
                  id="montoProximoPeriodo"
                  v-select-on-focus
                  currency="$"
                  thousand-separator="."
                  decimal-separator=","
                  :precision="2"
                  v-model="montoProximoPeriodo"
                  :minus="true"
                  class="form-control form-control-sm text-center bg-white"
                ></vue-numeric>
              </div>
            </template>
          </div>
          <div class="row" v-if="showEmpresasSelector">
            <div class="col-12 form-group form-group-sm">
              <label for="selectEmpresas"> Empresas del cliente </label>
              <SelectorEmpresasDelCliente
                :idCliente="idCliente"
                v-model="empresa"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="d-flex justify-content-between">
                <button
                  @click="cerrarModal"
                  type="button"
                  class="btn btn-danger"
                >
                  Cancelar
                </button>
                <button type="submit" class="btn btn-primary">Confirmar</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </b-modal>
</template>
<script>
import moment from "moment";
import NombreCliente from "../Clientes/shared/NombreCliente";
import { formatMDecimalConPunto } from "@/lib/utils/accountingJsFns";
import SelectorEmpresasDelCliente from "../Clientes/shared/SelectorEmpresasDelCliente.vue";
import axios from "axios";
import vueNumeric from "../../lib/utils/vue-numeric.vue";

export default {
  name: "saldo-al-mes-siguiente-modal",
  props: ["situacionCliente"],
  mixins: [NombreCliente],
  components: { SelectorEmpresasDelCliente, vueNumeric },
  mounted() {
    this.getNombreCliente(this.situacionCliente.id_cliente);
    this.$store.dispatch(
      "Empresas/getEmpresas",
      this.situacionCliente.id_cliente,
    );
  },
  data: () => ({
    montoProximoPeriodo: 0,
    deudaUltimaFactura: 0,
    variasEmpresas: false,
    empresa: null,
  }),
  computed: {
    idCliente() {
      return this.situacionCliente.id_cliente;
    },
    isMontoOk() {
      return !!this.montoAPagar;
    },
    isLugarPagoOk() {
      return this.lugarCobranza !== null;
    },
    Fecha() {
      const fechaIngreso = moment().format("YYYY-MM-DD HH:mm");
      return fechaIngreso;
    },
    empresas: {
      get() {
        return this.$store.state.Empresas.empresas;
      },
      set(val) {
        this.$store.commit("Empresas/setEmpresas", val);
      },
    },
    showEmpresasSelector() {
      return this.empresas && this.empresas.length > 1;
    },
  },
  methods: {
    async submit() {
      const resp = await axios.post("/execute", {
        method: "CLI.IngresarPagoConSaldoAPeriodoProximo",
        parameters: [
          { name: "id_cliente", value: this.idCliente },
          { name: "monto_ultima_factura", value: this.deudaUltimaFactura },
          {
            name: "monto_al_siguiente_periodo",
            value: this.montoProximoPeriodo,
          },
          {
            name: "id_empresa",
            value: this.empresa ? this.empresa.id_empresa : null,
          },
        ],
      });
      if (resp.data.ok) {
        this.exito();
        this.cerrarModal();
      } else {
        this.$msgBoxOk(resp.data.message);
      }
    },
    async exito() {
      this.$msgBoxOk("Se pasó el saldo para el próximo abono");
    },
    cerrarModal() {
      this.$bvModal.hide("saldo-al-mes-siguiente");
    },
    onShown() {
      this.deudaUltimaFactura = this.situacionCliente.ultima_factura
        ? formatMDecimalConPunto(this.situacionCliente.ultima_factura)
        : 0;
      this.montoProximoPeriodo = formatMDecimalConPunto(0);
    },
  },
};
</script>
